import React, { forwardRef } from "react";
import { InlineButtonPropsModel } from "./InlineButton.types";
import { ButtonBase } from "@material-ui/core";
import clsx from "clsx";
import { InlineButtonIcon } from "./InlineButtonIcon";
import { CircularSpinner } from "../CircularSpinner/CircularSpinner";

import useStyles from "./InlineButton.style";

export const InlineButton = forwardRef<HTMLButtonElement, InlineButtonPropsModel>(
  (
    {
      children,
      className,
      ariaLabel,
      ariaExpanded,
      autoFocus,
      tabIndex,
      testId = 'inline-button',
      autoTestId,
      disabled,
      onClick,
      onKeyDown,
      size = "default",
      variant = "button",
      customIcon,
      customIconClassName,
      iconType,
      iconPlacement = "right",
      buttonType = "button",
      isLoading,
    },
    ref,
  ) => {
    const c = useStyles({ size, variant });
    const iconDefined = !!customIcon || !!iconType;
    const isDefinedIconLeft = iconDefined && iconPlacement === "left";
    const isDefinedIconRight = iconDefined && iconPlacement === "right";
    return (
      <ButtonBase
        ref={ref}
        disabled={disabled}
        className={clsx(c.root, className)}
        aria-label={ariaLabel}
        aria-expanded={ariaExpanded}
        autoFocus={autoFocus}
        tabIndex={tabIndex}
        data-testid={testId}
        data-autotestid={autoTestId}
        onClick={disabled ? undefined : onClick}
        onKeyDown={disabled ? undefined : onKeyDown}
        data-type="ui/InlineButton"
        type={buttonType}
      >
        <span className={clsx(c.content, isLoading && c.isLoading)}>
          {isDefinedIconLeft && (
            <InlineButtonIcon iconType={iconType} customIcon={customIcon} className={customIconClassName} />
          )}
          {children}
          {isDefinedIconRight && (
            <InlineButtonIcon iconType={iconType} customIcon={customIcon} className={customIconClassName} />
          )}
        </span>
        {isLoading && <CircularSpinner size="small" className={c.spinner} />}
      </ButtonBase>
    );
  },
);

InlineButton.displayName = "InlineButton";
